export default __webpack_public_path__ + "scene1_1_icon170364.png";